import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import handleClickAway from './utilities/handleClickAway'
import styles from './styles.module.scss'
// import Styles from "./utilities/styles.module.scss";
import WebpImage from '../../../components/WebpImage'
import dropdownItems from '../../../constants/dropdownItems'
import IcProyugaLogo from '../../Icons/IcProyugaLogo'
import {
  goToHome,
  goToiBC,
  goToTeam,
  goToOffices,
  scrollToHome,
  scrollToOffices,
  scrollToLearners,
  scrollToiBC,
  scrollToBusiness,
  scrollToGameDevelopers,
  scrollToContactUs
} from '../../../utils/navigationUtils'

import { OFFICE_SECTION, IBC_SECTION } from '../../../constants/RouteConstants'
import {
  ContactUsMenuItem,
  IBCricketMenuItem,
  TeamMenuItem,
  CareerMenuItem,
  HomeMenuItem,
  OfficesMenuItem,
  FBIcon,
  TwitterIcon,
  MenuIcon,
  HeaderElement,
  PageContainer,
  Img,
  ImageLink,
  MenuDropdown,
  DropDownArrow,
  MobileCollapseMenuItem,
  MobileMenuButton,
  MobileNavContainer,
  MobileNavContent,
  SidebarContainer,
  InvestorMenuItem
} from '../../HeaderMenuSection/styledComponents'

import { ThemeProvider } from 'emotion-theming'
import commonDefaultTheme from '../../../constants/themeConstants'

import {
  Modal,
  Button,
  Nav,
  Navbar,
  NavItem,
  NavDropdown,
  MenuItem
} from 'react-bootstrap'
import Link from 'gatsby-link'
import DropdownButton from '../../Dropdown'
import StakeHoldersDropdown from '../../StakeHoldersDropdown'
import HamburgerIcon from '../../Icons/HamburgerIcon'
import $ from 'jquery'
import SideNavbar from './SideNavbar'

import './index.global.scss'

const scrollToSection = section => {
  let spaceLeft = 70
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (window.innerWidth < 769) {
      spaceLeft = 45
    }
    $('html, body').animate(
      {
        scrollTop: $(section).offset().top - spaceLeft
      },
      1000
    )
  }
}

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      didScroll: false,
      sideNavOpen: false,
      isOpen: false
    }
    this.handleScroll = this.handleScroll.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.closeNav = this.closeNav.bind(this)
  }

  // only handle scroll state if menu closed
  handleScroll() {
    if (!this.state.sideNavOpen) {
      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (window.pageYOffset > 50) {
          this.setState({ didScroll: true })
        } else {
          this.setState({ didScroll: false })
        }
      }
    }
  }

  // check page and set header

  closeNav(e) {
    const toggleNode = this.refs.toggle
    const isOutsideClick = handleClickAway(toggleNode, e)
    if (toggleNode && isOutsideClick) {
      this.setState({
        sideNavOpen: false
      })
    }
  }

  //don't delete this dropdownToggle function
  dropdownToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  //on selcting an item modal will be closed
  onSelect = e => {
    this.setState({ isOpen: false })
  }

  handleClick() {
    this.setState(previousState => ({
      sideNavOpen: !previousState.sideNavOpen
    }))
  }
  toggleNavMenu = () => {
    // this.setState({ sideNavOpen: !this.state.sideNavOpen })
  }
  //function for opening dropdown menu
  handleDropdownOpen = () => {
    this.setState({ isOpen: true })
  }

  //function for closing dropdown menu
  handleDropdownClose = () => {
    this.setState({ isOpen: false })
  }

  isHomeVisible = () => {
    const { showHome, isHome } = this.props
    const { didScroll } = this.state
    if (showHome) {
      if (isHome && !didScroll) {
        return false
      }
      return true
    }
    return false
  }

  componentDidMount() {
    try {
      this.sidebar = document.getElementById('sidenavbar')
    } catch (err) {}
    if (this.state.sideNavOpen == true) {
      document.body.style.overflowY = 'hidden'
    } else {
      document.body.style.overflowY = 'scroll'
    }

    if (typeof window !== undefined) {
      window.addEventListener('scroll', this.handleScroll)
      document.body.addEventListener('click', this.closeNav)
    }
  }

  componentWillUnmount() {
    try {
      document.getElementById('sidenav').style.transition = '0.5s'
      document.getElementById('sidenav').style.transitionDelay = '0.3s'
      document.getElementById('sidenav').style.width = '304px'
    } catch (err) {
      // console.log('Exception raised in componentWillUnmount')
    }
    if (typeof window !== undefined) {
      window.removeEventListener('scroll', this.handleScroll)
      document.body.removeEventListener('click', this.closeNav)
    }
  }

  componentWillMount() {
    this.handleScroll()
  }

  navigateTo = path => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      window.open(path)
    }
  }

  handleOfficeOnClick = e => {
    e.preventDefault()
    this.props.goToOffices(e)
  }
  openMobileSideNav = () => {
    document.body.style.overflow = 'hidden'
    this.setState({ sideNavOpen: true })
  }

  closeMobileSideNav = e => {
    try {
      this.setState({ sideNavOpen: false })
      document.body.style.overflow = 'scroll'
    } catch (err) {}
  }

  preventDefault = e => {
    e = e || window.event
    if (e.preventDefault) e.preventDefault()
    e.returnValue = false
  }

  preventDefaultForScrollKeys = e => {
    if (keys[e.keyCode]) {
      preventDefault(e)
      return false
    }
  }

  disableScroll = () => {
    if (window.addEventListener)
      window.addEventListener('DOMMouseScroll', this.preventDefault, false)
    window.onwheel = this.preventDefault // modern standard
    window.onmousewheel = document.onmousewheel = this.preventDefault // older browsers, IE
    window.ontouchmove = this.preventDefault // mobile
    document.onkeydown = this.preventDefaultForScrollKeys
  }

  enableScroll = () => {
    if (window.removeEventListener)
      window.removeEventListener('DOMMouseScroll', this.preventDefault, false)
    window.onmousewheel = document.onmousewheel = null
    window.onwheel = null
    window.ontouchmove = null
    document.onkeydown = null
  }

  scrollToContactUs = () => {
    this.props.goToContactUs()
  }

  render() {
    let presentURL = false
    let isMobileDevice = false

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (window.location.pathname === '/') {
        presentURL = true
      }
      if (window.innerWidth < 768) {
        isMobileDevice = true
      }
    }

    const {
      customStyle,
      showHome,
      logoSrc,
      scrooledLogoSrc,
      navColor,
      navScrolledColor,
      showNavLogo,
      fontColor,
      scrolledFontColor,
      navBorderColor,
      navScrolledBorderColor,
      scrolled,
      url,
      faqPage,
      showTeam,
      showOffice,
      isHome,
      showContactUs,
      showiBCricket,
      showServices,
      goToiBC,
      goToHome,
      goToTeam,
      goToContactUs,
      defaulttheme,
      defaultBackground,
      scrolledBackground,
      showBorder
    } = this.props
    const { sideNavOpen, didScroll } = this.state
    const mobileNav = sideNavOpen ? styles.open : ''
    const openClass = sideNavOpen ? styles.animate : ''

    let istransparentNavBar = didScroll ? '' : styles.transparentNavBar
    let isTransparentMobileNav = didScroll
      ? styles.nonTransparentMobileNav
      : styles.transparentMobileNav

    if (!isMobileDevice) {
      return (
        <React.Fragment>
          <section id="headerSection">
            <HeaderElement
              isDark={didScroll}
              isScrolled={didScroll}
              showBorder={showBorder}
              defaultBackground={defaultBackground}
              scrolledBackground={scrolledBackground}
            >
              <PageContainer>
                <ImageLink href="/" title="Proyuga" isScrolled={didScroll}>
                  {showBorder ? (
                    <IcProyugaLogo
                      width={42}
                      height={50}
                      fillTextColor="#016CAF"
                      logoColor="#46C7F4"
                    />
                  ) : didScroll ? (
                    <IcProyugaLogo
                      width={42}
                      height={50}
                      fillTextColor="#016CAF"
                      logoColor="#46C7F4"
                    />
                  ) : (
                    <IcProyugaLogo
                      width={71}
                      height={86}
                      fillTextColor="#ffffff"
                      logoColor="#ffffff"
                    />
                  )}
                </ImageLink>
                <nav className={`${styles.nav} ${mobileNav}`}>
                  <ul className={styles.navItems}>
                    {this.isHomeVisible() ? (
                      isHome ? (
                        <HomeMenuItem
                          onClick={scrollToHome}
                          isScrolled={didScroll}
                        />
                      ) : (
                        <HomeMenuItem
                          scrollTo={goToHome}
                          isScrolled={didScroll}
                        />
                      )
                    ) : null}
                    {showiBCricket ? (
                      isHome ? (
                        <IBCricketMenuItem
                          isScrolled={didScroll}
                          onClick={scrollToiBC}
                        />
                      ) : (
                        <IBCricketMenuItem
                          linkTo={IBC_SECTION}
                          isScrolled={didScroll}
                        />
                      )
                    ) : null}
                    {showServices ? (
                      <DropdownButton
                        onhover={true}
                        dropdownStyle={{ left: 0, right: 0 }}
                        buttonComponent={
                          <MenuDropdown isScrolled={didScroll}>
                            Services<DropDownArrow
                              width={10}
                              height={6}
                              fillColor={
                                showBorder
                                  ? '#43484c'
                                  : didScroll ? '#43484c' : 'white'
                              }
                            />
                          </MenuDropdown>
                        }
                      >
                        <StakeHoldersDropdown {...this.props} />
                      </DropdownButton>
                    ) : null}
                    {showTeam ? (
                      <TeamMenuItem
                        isScrolled={didScroll}
                        showMargin={!showServices}
                      />
                    ) : null}
                    <InvestorMenuItem 
                        isScrolled={didScroll}
                        showMargin={!showServices}/>
                      <CareerMenuItem
                        isScrolled={didScroll}
                        showMargin={!showServices}
                      />
                    {showOffice ? (
                      isHome ? (
                        <OfficesMenuItem
                          isScrolled={didScroll}
                          onClick={scrollToOffices}
                        />
                      ) : (
                        <OfficesMenuItem
                          isScrolled={didScroll}
                          linkTo={OFFICE_SECTION}
                        />
                      )
                    ) : null}
                    {showContactUs ? (
                      <ContactUsMenuItem
                        scrollTo={goToContactUs}
                        isScrolled={didScroll}
                      />
                    ) : null}
                  </ul>
                </nav>
              </PageContainer>
            </HeaderElement>
          </section>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <section id="headerSection">
            <MobileNavContainer
              isDark={didScroll}
              isScrolled={didScroll}
              showBorder={showBorder}
              defaultBackground={defaultBackground}
              scrolledBackground={scrolledBackground}
            >
              <MobileNavContent isScrolled={didScroll}>
                <ImageLink href="/" title="Proyuga" isScrolled={didScroll}>
                  {showBorder ? (
                    <IcProyugaLogo
                      width={42}
                      height={50}
                      fillTextColor="#016CAF"
                      logoColor="#46C7F4"
                    />
                  ) : didScroll ? (
                    <IcProyugaLogo
                      width={42}
                      height={50}
                      fillTextColor="#016CAF"
                      logoColor="#46C7F4"
                    />
                  ) : (
                    <IcProyugaLogo
                      width={71}
                      height={86}
                      fillTextColor="#ffffff"
                      logoColor="#ffffff"
                    />
                  )}
                </ImageLink>

                <MobileMenuButton
                  isScrolled={didScroll}
                  onClick={this.openMobileSideNav}
                >
                  <HamburgerIcon
                    fillColor={
                      showBorder ? '#43484c' : didScroll ? '#43484c' : 'white'
                    }
                  />
                </MobileMenuButton>
                {this.sidebar
                  ? ReactDOM.createPortal(
                      <SideNavbar
                        toggleNavMenu={this.toggleNavMenu}
                        isOpen={sideNavOpen}
                        closeSideNavbar={this.closeMobileSideNav}
                        scrollToiBC={scrollToiBC}
                        scrollToContactUs={this.scrollToContactUs}
                        {...this.props}
                      />,
                      this.sidebar
                    )
                  : null}
              </MobileNavContent>
            </MobileNavContainer>
          </section>
        </React.Fragment>
      )
    }
  }
}

Header.contextTypes = {
  metadata: PropTypes.object
}

Header.defaultProps = {
  navColor: 'white',
  navScrolledColor: 'white',
  fontColor: 'white',
  scrolledFontColor: '#07396c',
  navBorderColor: 'transparent',
  navScrolledBorderColor: 'transparent',
  showNavLogo: true,
  logoSrc: '',
  homePage: false,
  scrolled: false,
  customStyle: {},
  scrooledLogoSrc: '/assets/images/ProyugaLogo/Proyuga-Img.png',
  faqPage: true,
  showTeam: true,
  showOffice: false,
  showContactUs: true,
  showHome: true,
  isHome: false,
  showServices: true,
  showiBCricket: true,
  goToHome: goToHome,
  goToContactUs: scrollToContactUs,
  defaulttheme: commonDefaultTheme,
  defaultBackground: 'transparent',
  scrolledBackground: '#ffffff',
  showBorder: false
}
export default Header
